import { gql } from '@apollo/client';

export const LOGIN = gql`
  mutation RealtorLogin($data: String!) {
    realtorLogin(data: $data) {
      token
      status
      message
      realtor {
        isEmailVerified
        firstName
        lastName
        createdAt
        email
        noOfUnits
        phone
      }
    }
  }
`;

export const REALTOR_LOGIN_WITH_GOOGLE = gql`
  mutation realtorLoginWithGoogle($accessToken: String!) {
    realtorLoginWithGoogle(accessToken: $accessToken) {
      token
      status
      message
      realtor {
        isEmailVerified
        firstName
        lastName
        createdAt
        email
        noOfUnits
        phone
      }
    }
  }
`;

export const REALTOR_LOGIN_WITH_FACEBOOK = gql`
  mutation RealtorLoginWithFacebook($accessToken: String!) {
    realtorLoginWithFacebook(accessToken: $accessToken) {
      token
      status
      message
      realtor {
        isEmailVerified
        firstName
        lastName
        createdAt
        email
        noOfUnits
        phone
      }
    }
  }
`;

export const LOGIN_BY_PHONE = gql`
  mutation LoginByPhone($data: String!) {
    loginByPhoneCa(data: $data) {
      token
      message
      status
      user {
        isEmailVerified
        firstName
        lastName
        createdAt
        lastLoginAt
        email
        employmentdetail {
          employmentStatus
        }
      }
    }
  }
`;

export const CREATE_KAABO_LANDLORD = gql`
  mutation CreateKaaboLandlord($data: String!) {
    createKaaboLandlord(data: $data) {
      message
      realtor {
        noOfUnits
        email
        firstName
        isEmailVerified
        isPhoneVerified
        lastName
        phone
        selfie
        status
        communicationAddress
      }
      status
      token
    }
  }
`;

export const CREATE_REALTOR_ACCOUNT_WITH_GOOGLE = gql`
  mutation CreateRealtorAccountWithGoogle(
    $accessToken: String!
    $referralCode: String
    $country: String
  ) {
    createRealtorAccountWithGoogle(
      accessToken: $accessToken
      referralCode: $referralCode
      country: $country
    ) {
      message
      realtor {
        noOfUnits
        email
        firstName
        isPhoneVerified
        isEmailVerified
        lastName
        phone
        selfie
        status
        communicationAddress
      }
      status
      token
    }
  }
`;

export const CREATE_REALTOR_ACCOUNT_WITH_FACEBOOK = gql`
  mutation CreateRealtorAccountWithFacebook(
    $accessToken: String!
    $referralCode: String
    $country: String
  ) {
    createRealtorAccountWithFacebook(
      accessToken: $accessToken
      referralCode: $referralCode
      country: $country
    ) {
      message
      realtor {
        noOfUnits
        email
        firstName
        isPhoneVerified
        isEmailVerified
        lastName
        phone
        selfie
        status
        communicationAddress
      }
      status
      token
    }
  }
`;

export const GET_OTP_FOR_LOGIN = gql`
  mutation GetOTPforLogin($phone: String!) {
    getOTPforLogin(phone: $phone) {
      message
      status
    }
  }
`;

export const LOGIN_WITH_PHONE_AND_OTP = gql`
  mutation loginWithPhoneAndOTPCa($phone: String!, $otp: String!) {
    loginWithPhoneAndOTPCa(phone: $phone, otp: $otp) {
      token
      message
      status
      user {
        isEmailVerified
        firstName
        lastName
        createdAt
        lastLoginAt
        email
        employmentdetail {
          employmentStatus
        }
      }
    }
  }
`;

export const FORGOT_PASSWORD_BY_PHONE = gql`
  mutation forgotPasswordByPhone($phone: String!) {
    forgotPasswordByPhone(phone: $phone) {
      status
      message
    }
  }
`;

export const RESET_PASSWORD_BY_EMAIL = gql`
  mutation ResetPasswordRealtor($data: String!) {
    resetPasswordRealtor(data: $data) {
      status
      message
    }
  }
`;

export const RESET_PASSWORD_BY_PHONE = gql`
  mutation resetPasswordByPhoneCa($data: String!) {
    resetPasswordByPhoneCa(data: $data) {
      status
      message
    }
  }
`;

export const RESEND_REALTOR_EMAIL_OTP = gql`
  mutation resendRealtorEmailOtp($email: String!, $isKaabo: Boolean) {
    resendRealtorEmailOtp(email: $email, isKaabo: $isKaabo) {
      status
      phone
      message
      isNewUser
      email
    }
  }
`;

export const VERIFY_REALTOR_EMAIL_OTP = gql`
  mutation VerifyRealtorEmailOTP($otp: String!, $email: String!) {
    verifyRealtorEmailOTP(otp: $otp, email: $email) {
      message
      status
    }
  }
`;

export const SEND_PHONE_VERIFICATION_CODE_REALTOR = gql`
  mutation SendPhoneVerificationCodeRealtor($phone: String) {
    sendPhoneVerificationCodeRealtor(phone: $phone) {
      message
      sentTo
      status
    }
  }
`;

export const VERIFY_PHONE_REALTOR = gql`
  mutation VerifyPhoneRealtor($code: String!, $phone: String!) {
    verifyPhoneRealtor(code: $code, phone: $phone) {
      message
      sentTo
      status
    }
  }
`;
export const UPLOAD_REALTOR_SELFIE = gql`
  mutation updateRealtorSelfie($imageStr: String) {
    updateRealtorSelfie(imageStr: $imageStr) {
      status
      message
      data {
        selfie
      }
    }
  }
`;

export const ADD_REALTOR_DOC = gql`
  mutation AddRealtorDocument($name: String!, $file: Upload!, $isOthers: Boolean) {
    addRealtorDocument(name: $name, file: $file, isOthers: $isOthers) {
      message
      status
      data {
        id
        uri
        meta {
          isOthers
          file_size
          docOption
          contentType
        }
      }
    }
  }
`;

export const UPDATE_REALTOR_USER_DOC = gql`
  mutation UpdateRealtorDocument(
    $updateRealtorDocumentId: String!
    $file: Upload
    $name: String
    $isOthers: Boolean
  ) {
    updateRealtorDocument(
      id: $updateRealtorDocumentId
      file: $file
      name: $name
      isOthers: $isOthers
    ) {
      message
      status
      data {
        meta {
          contentType
          docOption
          file_size
          isOthers
        }
        uri
        id
        fileName
        file_ext
        documentType
        docKey
        status
        documentId
      }
    }
  }
`;

export const UPDATE_REALTOR = gql`
  mutation UpdateRealtor(
    $communicationAddress: String
    $country: String
    $city: String
    $postalCode: String
  ) {
    updateRealtor(
      communicationAddress: $communicationAddress
      country: $country
      city: $city
      postalCode: $postalCode
    ) {
      data {
        firstName
        email
      }
      message
      status
    }
  }
`;

export const CREATE_TENANT = gql`
  mutation CreateTenant(
    $firstName: String
    $lastName: String
    $email: String
    $phone: String
    $propertyId: String
    $realtorPropertyBedroomId: String
    $unitNumbers: [String]
  ) {
    createTenant(
      firstName: $firstName
      lastName: $lastName
      email: $email
      phone: $phone
      propertyId: $propertyId
      realtorPropertyBedroomId: $realtorPropertyBedroomId
      unitNumbers: $unitNumbers
    ) {
      message
      status
      data {
        status
        id
        userId
      }
    }
  }
`;

export const UPDATE_TENANT_GENERAL_INFO = gql`
  mutation UpdateTenantGeneralInfo(
    $tenantId: String!
    $firstName: String
    $lastName: String
    $email: String
    $phone: String
    $propertyId: String
    $realtorPropertyBedroomId: String
    $unitNumbers: [String]
  ) {
    updateTenantGeneralInfo(
      tenantId: $tenantId
      firstName: $firstName
      lastName: $lastName
      email: $email
      phone: $phone
      propertyId: $propertyId
      realtorPropertyBedroomId: $realtorPropertyBedroomId
      unitNumbers: $unitNumbers
    ) {
      status
      message
    }
  }
`;

export const EDIT_TENANT_PAYMENTSETUP = gql`
  mutation EditTenantPaymentSetup(
    $tenantId: String!
    $rentAmount: Float!
    $rentDueDay: Int
    $leaseStartDate: String
    $leaseEndDate: String
    $rentProtection: Boolean
  ) {
    editTenantPaymentSetup(
      tenantId: $tenantId
      rentAmount: $rentAmount
      rentDueDay: $rentDueDay
      leaseStartDate: $leaseStartDate
      leaseEndDate: $leaseEndDate
      rentProtection: $rentProtection
    ) {
      status
      message
      data {
        id
        userId
        realtorId
      }
    }
  }
`;

export const EDIT_TENANT_DOCUMENT_UPLOAD = gql`
  mutation EditTenantDocumentUpload($tenantId: String!, $files: [TenantFiles]) {
    editTenantDocumentUpload(tenantId: $tenantId, files: $files) {
      status
      message
      data {
        documents {
          id
          documentType
          docKey
          fileName
          file_ext
          tenantId
          meta
        }
      }
    }
  }
`;

export const EDIT_TENANT_SINGLE_DOCUMENT_UPLOAD = gql`
  mutation EditTenantSingleDocumentUpload(
    $editTenantSingleDocumentUploadTenantId2: ID!
    $file: Upload
  ) {
    editTenantSingleDocumentUpload(
      tenantId: $editTenantSingleDocumentUploadTenantId2
      file: $file
    ) {
      status
      message
    }
  }
`;

export const DELETE_TENANT_DOCUMENT = gql`
  mutation DeleteTenantDocument($tenantId: String!, $documentId: String!) {
    deleteTenantDocument(tenantId: $tenantId, documentId: $documentId) {
      status
      message
    }
  }
`;

export const ADD_REALTOR_PROPERTY = gql`
  mutation AddRealtorProperty(
    $propertyName: String!
    $managerFullName: String!
    $managerPhone: String
    $managerEmail: String
    $propertyType: String
    $description: String
    $unitAvaialable: Int
    $unitSize: Float
    $keyFeatures: [String]
    $otherFeatures: [String]
    $rentalAddress: String
    $city: String
    $state: String
    $zipCode: String
    $paymentReminders: [String]
    $typeOfHome: String
    $bedroomCount: String
    $rentAmount: Float
  ) {
    addRealtorProperty(
      propertyName: $propertyName
      managerFullName: $managerFullName
      managerPhone: $managerPhone
      managerEmail: $managerEmail
      propertyType: $propertyType
      description: $description
      unitAvaialable: $unitAvaialable
      unitSize: $unitSize
      keyFeatures: $keyFeatures
      otherFeatures: $otherFeatures
      rentalAddress: $rentalAddress
      city: $city
      state: $state
      zipCode: $zipCode
      paymentReminders: $paymentReminders
      typeOfHome: $typeOfHome
      bedroomCount: $bedroomCount
      rentAmount: $rentAmount
    ) {
      status
      message
      data {
        id
      }
    }
  }
`;

export const UPDATE_REALTOR_PROPERTY = gql`
  mutation UpdateRealtorProperty(
    $updateRealtorPropertyId: ID!
    $propertyName: String!
    $managerFullName: String!
    $managerPhone: String
    $managerEmail: String
    $propertyType: String
    $description: String
    $unitAvaialable: Int
    $unitSize: Float
    $keyFeatures: [String]
    $otherFeatures: [String]
    $rentalAddress: String
    $city: String
    $state: String
    $zipCode: String
    $paymentReminders: [String]
    $typeOfHome: String
    $bedroomCount: String
    $rentAmount: Float
  ) {
    updateRealtorProperty(
      id: $updateRealtorPropertyId
      propertyName: $propertyName
      managerFullName: $managerFullName
      managerPhone: $managerPhone
      managerEmail: $managerEmail
      propertyType: $propertyType
      description: $description
      unitAvaialable: $unitAvaialable
      unitSize: $unitSize
      keyFeatures: $keyFeatures
      otherFeatures: $otherFeatures
      rentalAddress: $rentalAddress
      city: $city
      state: $state
      zipCode: $zipCode
      paymentReminders: $paymentReminders
      typeOfHome: $typeOfHome
      bedroomCount: $bedroomCount
      rentAmount: $rentAmount
    ) {
      status
      message
      data {
        id
      }
    }
  }
`;

export const REALTOR_ACCOUNT_SETUP = gql`
  mutation RealtorAccountSetup(
    $type: String!
    $tenantId: String!
    $email: String
    $accountNumber: String
    $bankId: Int
    $bankBranchId: Int
    $transitCode: String
    $bankName: String
    $bankCode: String
  ) {
    realtorAccountSetup(
      type: $type
      tenantId: $tenantId
      email: $email
      accountNumber: $accountNumber
      bankId: $bankId
      bankBranchId: $bankBranchId
      transitCode: $transitCode
      bankName: $bankName
      bankCode: $bankCode
    ) {
      message
      status
    }
  }
`;

export const REALTOR_CREATE_ACCOUNT = gql`
  mutation CreateAccount(
    $type: String!
    $accountNumber: String!
    $accountName: String!
    $routingNumber: String
    $transitNumber: String
    $email: String
    $institutionNumber: String
  ) {
    createAccount(
      type: $type
      accountNumber: $accountNumber
      accountName: $accountName
      routingNumber: $routingNumber
      transitNumber: $transitNumber
      email: $email
      institutionNumber: $institutionNumber
    ) {
      message
      status
    }
  }
`;

export const CREATE_EDIT_TENANCY_ACCOUNT_INFORMATION = gql`
  mutation CreateEditTenancyAccountInformation(
    $tenantId: String!
    $accountId: String!
    $padStatus: Boolean!
  ) {
    createEditTenancyAccountInformation(
      tenantId: $tenantId
      accountId: $accountId
      PADStatus: $padStatus
    ) {
      status
      message
      data {
        id
      }
    }
  }
`;

export const TENANTCREATIONCOMPLETE = gql`
  mutation TenantCreationComplete($tenantId: String!) {
    tenantCreationComplete(tenantId: $tenantId) {
      status
      message
    }
  }
`;

export const DELETE_REALTOR_PROPERTY_LISTING = gql`
  mutation DeleteRealtorPropertyListing($deleteRealtorPropertyListingId: ID!) {
    deleteRealtorPropertyListing(id: $deleteRealtorPropertyListingId) {
      status
      message
    }
  }
`;

export const DEACTIVATE_REALTOR_PROPERTY_LISTING = gql`
  mutation DeactivateRealtorPropertyListing($deactivateRealtorPropertyListingId: ID!) {
    deactivateRealtorPropertyListing(id: $deactivateRealtorPropertyListingId) {
      status
      message
    }
  }
`;

export const ACTIVATE_REALTOR_PROPERTY_LISTING = gql`
  mutation ActivateRealtorPropertyListing($activateRealtorPropertyListingId: ID!) {
    activateRealtorPropertyListing(id: $activateRealtorPropertyListingId) {
      message
      status
    }
  }
`;

export const DELETE_REALTOR_PROPERTY_IMAGE = gql`
  mutation DeleteRealtorPropertyImage($deleteRealtorPropertyImageId: ID!, $realtorPropertyId: ID!) {
    deleteRealtorPropertyImage(
      id: $deleteRealtorPropertyImageId
      realtorPropertyId: $realtorPropertyId
    ) {
      status
      message
    }
  }
`;

export const CREATE_ACCOUNT = gql`
  mutation CreateAccount(
    $type: String!
    $email: String
    $accountNumber: String
    $bankId: Int
    $bankBranchId: Int
    $bankCode: String
    $accountName: String
    $transitCode: String
    $bankName: String
  ) {
    createAccount(
      type: $type
      email: $email
      accountNumber: $accountNumber
      bankId: $bankId
      bankBranchId: $bankBranchId
      bankCode: $bankCode
      accountName: $accountName
      transitCode: $transitCode
      bankName: $bankName
    ) {
      status
      message
      data {
        id
        realtorId
        accountName
        accountNumber
        bankBranchId
        bankCode
        bankId
        bankName
        createdAt
        email
        providerCustomerId
        transitCode
        type
        updatedAt
      }
    }
  }
`;

export const UPDATE_TENANT = gql`
  mutation UpdateTenant(
    $tenantId: String!
    $rentProtection: Boolean
    $rentDueDay: Int
    $leaseEndDate: String
    $leaseStartDate: String
    $leaseDuration: String
    $files: [TenantFiles]
    $rentAmount: Float
    $unit: String
    $accountId: String
    $propertyId: String
    $phone: String
    $email: String
    $lastName: String
    $firstName: String
  ) {
    updateTenant(
      tenantId: $tenantId
      rentProtection: $rentProtection
      rentDueDay: $rentDueDay
      leaseEndDate: $leaseEndDate
      leaseStartDate: $leaseStartDate
      leaseDuration: $leaseDuration
      files: $files
      rentAmount: $rentAmount
      unit: $unit
      accountId: $accountId
      propertyId: $propertyId
      phone: $phone
      email: $email
      lastName: $lastName
      firstName: $firstName
    ) {
      message
      status
      data {
        id
        accountId
      }
    }
  }
`;

export const ADD_EDIT_REALTOR_PROPERTY_DETAILS = gql`
  mutation AddEditRealtorPropertyDetails(
    $propertyName: String!
    $realtorPropertyId: String
    $propertyType: String
    $typeOfHome: String
    $bedroomCount: String
    $roomAvailability: String
    $keyFeatures: [String]
    $otherFeatures: [String]
    $unitAvaialable: Int
    $unitSize: Float
    $rentalAddress: String
    $city: String
    $state: String
    $zipCode: String
    $description: String
    $landmark: String
    $proofOfOwnership: String
    $proofOfOwnershipFiles: [Upload]
    $placeId: String
    $bathroomCount: Float
  ) {
    addEditRealtorPropertyDetails(
      propertyName: $propertyName
      realtorPropertyId: $realtorPropertyId
      propertyType: $propertyType
      typeOfHome: $typeOfHome
      bedroomCount: $bedroomCount
      roomAvailability: $roomAvailability
      keyFeatures: $keyFeatures
      otherFeatures: $otherFeatures
      unitAvaialable: $unitAvaialable
      unitSize: $unitSize
      rentalAddress: $rentalAddress
      city: $city
      state: $state
      zipCode: $zipCode
      description: $description
      landmark: $landmark
      proofOfOwnership: $proofOfOwnership
      proofOfOwnershipFiles: $proofOfOwnershipFiles
      placeId: $placeId
      bathroomCount: $bathroomCount
    ) {
      status
      message
      data {
        id
      }
    }
  }
`;

export const EDIT_REALTOR_PROPERTY_BEDROOM_DETAILS = gql`
  mutation EditRealtorPropertyBedroomDetails(
    $realtorPropertyId: String!
    $bedroomDetails: [BedroomDetails]
  ) {
    editRealtorPropertyBedroomDetails(
      realtorPropertyId: $realtorPropertyId
      bedroomDetails: $bedroomDetails
    ) {
      status
      message
    }
  }
`;

export const RENEW_TENANCY = gql`
  mutation RenewTenancy($tenantId: String!) {
    renewTenancy(tenantId: $tenantId) {
      message
      status
    }
  }
`;

export const TERMINATE_TENANCY = gql`
  mutation TerminateTenancy($tenantId: String!) {
    terminateTenancy(tenantId: $tenantId) {
      message
      status
    }
  }
`;

export const CANCEL_TENANCY_INVITE = gql`
  mutation CancelInvite($tenantId: String!) {
    cancelInvite(tenantId: $tenantId) {
      message
      status
    }
  }
`;

export const RESEND_TENANCY_INVITE = gql`
  mutation ResendInvite($tenantId: String!) {
    resendInvite(tenantId: $tenantId) {
      message
      status
    }
  }
`;

export const EDIT_REALTOR_PROPERTY_MANAGER_DETAILS = gql`
  mutation EditRealtorPropertyManagerDetails(
    $realtorPropertyId: String!
    $managerFullName: String
    $managerPhone: String
    $managerEmail: String
  ) {
    editRealtorPropertyManagerDetails(
      realtorPropertyId: $realtorPropertyId
      managerFullName: $managerFullName
      managerPhone: $managerPhone
      managerEmail: $managerEmail
    ) {
      status
      message
    }
  }
`;

export const EDIT_REALTOR_PROPERTY_PAYMENT_SET_UP = gql`
  mutation EditRealtorPropertyPaymentSetUp(
    $realtorPropertyId: String!
    $rentAmount: Float
    $paymentReminders: [String]
  ) {
    editRealtorPropertyPaymentSetUp(
      realtorPropertyId: $realtorPropertyId
      rentAmount: $rentAmount
      paymentReminders: $paymentReminders
    ) {
      status
      message
    }
  }
`;

export const EDIT_REALTOR_PROPERTY_BEDROOM_PAYMENT = gql`
  mutation EditRealtorPropertyBedroomPayment(
    $realtorPropertyId: String!
    $applySameCost: Boolean!
    $bedroomPaymentDetails: [BedroomPaymentDetails]
    $minimumStay: String
    $rentAmount: Float
    $roomName: String
    $paymentReminders: [String]
  ) {
    editRealtorPropertyBedroomPayment(
      realtorPropertyId: $realtorPropertyId
      applySameCost: $applySameCost
      bedroomPaymentDetails: $bedroomPaymentDetails
      minimumStay: $minimumStay
      rentAmount: $rentAmount
      roomName: $roomName
      paymentReminders: $paymentReminders
    ) {
      status
      message
    }
  }
`;

export const ADD_REALTOR_PROPERTY_IMAGE = gql`
  mutation AddRealtorPropertyImage($file: Upload!, $realtorPropertyId: String, $imageType: String) {
    addRealtorPropertyImage(
      file: $file
      realtorPropertyId: $realtorPropertyId
      imageType: $imageType
    ) {
      status
      message
    }
  }
`;

export const DELETE_REALTOR_PROPERTY_BEDROOM_IMAGE = gql`
  mutation DeleteRealtorPropertyBedroomImage($id: ID!, $realtorPropertyId: ID!) {
    deleteRealtorPropertyBedroomImage(id: $id, realtorPropertyId: $realtorPropertyId) {
      status
      message
    }
  }
`;

export const APPROVE_LANDLORD_MATCH_REQUEST = gql`
  mutation ApproveLandlordMatchRequest($matchRequestId: ID!, $action: String!) {
    approveLandlordMatchRequest(matchRequestId: $matchRequestId, action: $action) {
      status
      message
      data {
        user {
          firstName
          lastName
        }
      }
    }
  }
`;

export const APPROVE_OR_REJECT_GROUP_MATCH_REQUEST = gql`
  mutation ApproveOrRejectMultiApplicationLandlordMatchRequest(
    $applicationGroupId: ID!
    $action: String!
  ) {
    approveOrRejectMultiApplicationLandlordMatchRequest(
      applicationGroupId: $applicationGroupId
      action: $action
    ) {
      status
      message
      data {
        id
      }
    }
  }
`;

export const CREATE_EDIT_REALTOR_AGREEMENTS = gql`
  mutation CreateEditRealtorAgreements(
    $agreementType: String!
    $tenantId: String!
    $realtorAgreementId: String
    $data: JSON
  ) {
    createEditRealtorAgreements(
      agreementType: $agreementType
      tenantId: $tenantId
      realtorAgreementId: $realtorAgreementId
      data: $data
    ) {
      status
      message
      data {
        id
        realtorId
        tenantId
        agreementType
        agreementS3Url
        realtorSignatureS3Url
        tenantSignatureS3Url
        realtorSignedRequired
        tenantSignedRequired
        tenantView
        status
        meta
        createdAt
        updatedAt
      }
    }
  }
`;

export const NOTIFY_TENANT_OF_REALTOR_AGREEMENT = gql`
  mutation NotifyTenantOfRealtorAgreement($realtorAgreementId: String!, $tenantId: String!) {
    notifyTenantOfRealtorAgreement(realtorAgreementId: $realtorAgreementId, tenantId: $tenantId) {
      status
      message
      data {
        id
        tenantView
        status
      }
    }
  }
`;

export const SIGN_REALTOR_AGREEMENT_BY_REALTOR = gql`
  mutation SignRealtorAgreementByRealtor(
    $realtorAgreementId: String!
    $tenantId: String!
    $signatureFile: Upload!
  ) {
    signRealtorAgreementByRealtor(
      realtorAgreementId: $realtorAgreementId
      tenantId: $tenantId
      signatureFile: $signatureFile
    ) {
      status
      message
      data {
        id
        realtorSignatureS3Url
        status
        meta
      }
    }
  }
`;

export const SIGN_REALTOR_AGREEMENT_BY_TENANT = gql`
  mutation SignRealtorAgreementByTenant(
    $realtorAgreementId: String!
    $tenantId: String!
    $signatureFile: Upload!
  ) {
    signRealtorAgreementByTenant(
      realtorAgreementId: $realtorAgreementId
      tenantId: $tenantId
      signatureFile: $signatureFile
    ) {
      status
      message
      data {
        id
        tenantSignatureS3Url
        status
        meta
      }
    }
  }
`;
